var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "employees-card" }, [
        _c(
          "div",
          { staticClass: "main" },
          [
            _c("div", { staticClass: "title-16 mb20" }, [_vm._v("白名单设置")]),
            _vm._v(" "),
            _c("el-form", [
              _c("div", { staticClass: "form-box" }, [
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v("白名单人员:")]
                        ),
                        _vm._v(" "),
                        _c("select-member", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.departmentObj.userList || [],
                            placeholder: "请选择白名单人员",
                          },
                          on: {
                            getSelectList: function ($event) {
                              return _vm.getSelectList($event, 1)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v("超级管理员:")]
                        ),
                        _vm._v(" "),
                        _c("select-member", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.departmentObj.adminList || [],
                            placeholder: "请选择考勤超级管理员",
                          },
                          on: {
                            getSelectList: function ($event) {
                              return _vm.getSelectList($event, 2)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tips" }, [
                          _vm._v(
                            "超级管理员支持管理所有考勤组，及全公司所有人的考勤统计数据"
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["hr:attendance:white:save"],
                                expression: "['hr:attendance:white:save']",
                              },
                            ],
                            staticClass: "ml70",
                            attrs: {
                              size: "small",
                              loading: _vm.loading,
                              type: "primary",
                            },
                            on: { click: _vm.submit },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }